import { useState, type FormEvent } from 'react';
import { Link } from 'react-router';

import { useAuth } from '@/api/auth';
import { ApiError } from '@/api/client';

import '../market/market.css';
import './login.css';

function errorText(cause: unknown): string {
  if (cause instanceof ApiError) {
    const detail = cause.detail as { detail?: unknown } | null;
    if (typeof detail?.detail === 'string') return detail.detail;
  }
  return 'Не удалось начать регистрацию';
}

export function SignupScreen() {
  const { signup } = useAuth();
  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (password !== confirm) {
      setError('Пароли не совпадают');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      const result = await signup({ email, password, display_name: displayName });
      setMessage(result.message);
    } catch (cause) {
      setError(errorText(cause));
      setBusy(false);
    }
  }

  return (
    <div className="market-page login-page">
      <section className="login-intro" aria-labelledby="signup-title">
        <div className="login-brand" aria-label="TRAVEL CORTEX"><span>TRAVEL</span><strong>CORTEX</strong><em>personal workspace</em></div>
        <div className="login-message"><span className="market-eyebrow">Новый аккаунт</span><h1 id="signup-title">Начните с живого поиска по Таиланду.</h1><p>После подтверждения адреса система создаст личное пространство и первый поисковый профиль.</p></div>
      </section>
      <section className="login-access" aria-label="Регистрация">
        <form onSubmit={submit} className="login-form">
          <div className="login-form-heading"><span className="market-eyebrow">Регистрация</span><h2>Создать аккаунт</h2><p>Ссылка подтверждения одноразовая и действует 24 часа.</p></div>
          {message ? <p role="status" className="login-notice">{message}</p> : null}
          <label className="login-password" htmlFor="signup-name"><span>Имя</span><input id="signup-name" autoComplete="name" required value={displayName} onChange={(event) => setDisplayName(event.target.value)} /></label>
          <label className="login-password login-password-following" htmlFor="signup-email"><span>Email</span><input id="signup-email" type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.target.value)} /></label>
          <label className="login-password login-password-following" htmlFor="signup-password"><span>Пароль</span><input id="signup-password" type="password" autoComplete="new-password" minLength={12} required value={password} onChange={(event) => setPassword(event.target.value)} /></label>
          <label className="login-password login-password-following" htmlFor="signup-confirm"><span>Повторите пароль</span><input id="signup-confirm" type="password" autoComplete="new-password" minLength={12} required value={confirm} onChange={(event) => setConfirm(event.target.value)} /></label>
          {error ? <p role="alert" className="login-error">{error}</p> : null}
          <button type="submit" disabled={busy || Boolean(message) || password.length < 12}><span>{busy ? 'Отправляем…' : 'Создать аккаунт'}</span><i aria-hidden>→</i></button>
          <p className="login-security">Уже есть аккаунт? <Link to="/login">Войти</Link></p>
        </form>
      </section>
    </div>
  );
}
